module.exports = __webpack_public_path__ + "img/main_logo.e1257e2a.png";